/**
 * @ngdoc directive
 * @name ce-app:LongStringFixerDirective
 *
 * @description
 *
 *
 * @restrict A
 * */
import angular from 'angular';

/* @ngInject */
export default function LongStringFixerDirective($window, $timeout) {
    return {
        restrict: 'A',
        scope: {
            checkString: '='
        },
        link: function (scope, elem, attr) {
            function longContentSolver() {
                if (elem[0].scrollWidth > elem[0].offsetWidth) {
                    switch (elem[0].tagName.toLowerCase()) {
                        case 'h1':
                            elem[0].classList.add('h2');
                            break;
                        case 'h2':
                            elem[0].classList.add('h3');
                            break;
                        case 'h3':
                            elem[0].classList.add('h4');
                            break;
                        case 'h4':
                            elem[0].classList.add('h5');
                            break;
                        case 'h5':
                        case 'h6':
                            elem[0].classList.add('h6');
                            break;
                        default:
                            elem[0].style.fontSize = '1em';
                    }

                    if (elem[0].scrollWidth > elem[0].offsetWidth) {
                        elem[0].classList.add('ellipsis');
                        elem[0].setAttribute('title', scope.checkString);
                    }
                }
            }

            function cleanUp() {
                angular.element($window).off('resize', longContentSolver);
            }

            // Handle page load
            $timeout(function () {
                attr.$observe('checkString', function () {
                    longContentSolver(elem, scope.checkString);
                });
            });

            // Handle resize event
            angular.element($window).on('resize', longContentSolver);

            // Clean-up mess
            scope.$on('$destroy', cleanUp);
        }
    };
}
